import { Route, Routes } from '@angular/router';
import * as _ from 'lodash';

import { HealthcheckComponent } from '../../components/pages/healthcheck/healthcheck.component';
import { LandingPageComponent } from '../../components/pages/landing-page/landing-page.component';
import { PageNotFoundComponent } from '../../components/pages/page-not-found/page-not-found.component';
import { NoAccessComponent } from '../../components/pages/no-access/no-access.component';
import { AuthGuard } from '../guards/auth.guard';
import { FeatureGuard } from '../guards/feature.guard';

export const appRoutes: Routes = [
  { path: 'healthcheck', component: HealthcheckComponent },
  // Explicit route for access denial used by FeatureGuard
  { path: 'no-access', component: NoAccessComponent },
  {
    path: 'rx-performance',
    loadChildren: () =>
      import(
        '../../components/rx-performance/rx-performance-routing.module'
      ).then((m) => m.RxPerformanceRoutingModule),
  },
  {
    path: 'rx-revcycle',
    loadChildren: () =>
      import('../../components/rx-revcycle/rx-revcycle-routing.module').then(
        (m) => m.RxRevcycleRoutingModule
      ),
  },
  {
    path: '',
    component: LandingPageComponent,
    data: {
      feature: 'UI::BiAppLink',
      shouldDetach: true,
    },
    canActivate: [AuthGuard, FeatureGuard],
  },
  { path: '**', component: PageNotFoundComponent },
];

export function componentFromRoute(route: string): Route {
  const myRoute = _.find(appRoutes, { path: route });
  return myRoute;
}
